import Vue from 'vue'
import StopCard from './_stop-card'
import template from './content.pug'

// @vue/component
export default Vue.extend({
  name: 'stop-index-content',
  template: template(),
  components: {StopCard},

  props: {
    stops: {
      type: Array,
      default() {
        return []
      },
    },

    tab: {
      type: Number,
      default: 1
    },

    emptyText: {
      type: String,
      default() {
        return Vue.i18n ? Vue.i18n.t('stops.sidepanel.empty') : ''
      }
    },

    allowFavorite: {
      type: Boolean,
      default: true
    },

    selectedStopId: {
      type: String,
      default: null, // Estado actual de selección
    }
  },

  methods: {
    stopClick(stop) {

      this.$emit('stop-click', stop)
    },

    setFavorite(stopId) {
      this.$emit('stop-favorite', stopId)
    }
  }
})
